import { useSelector } from 'react-redux';

import { RootState } from 'dashboard/redux/store';

/**
 * @name `useIsVTEInternal`
 *
 * A hook that returns whether the current user should have internal
 * fully-enabled editing capabilities for VTE. Piggybacks off of useIsPersonerd.
 *
 */
export default () => {
  return useSelector<RootState, boolean>((state) => {
    const isPersonerd =
      !!state.currentUser.impersonationMode ||
      state.currentUser.currentUser?.attributes?.['email-address']?.endsWith('@withpersona.com') ||
      false;
    return isPersonerd;
  });
};
